import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PbxContext from '../../context/PbxContext';
import {
  accessLocalStorage,
  getDataDashboard,
  exportReportGenerate,
  chartEndpointsReceiveds,
  chartHoursReceiveds,
  chartSectorsReceiveds,
  chartDaysReceiveds,
  chartResumeReceiveds,
  chartEndpointsSendeds,
  chartHoursSendeds,
  chartDaysSendeds,
  chartResumeSendeds,
  chartResumeInternals,
  exportReportGenerateLogs,
  logsReport,
} from '../../services';

import '../../libs/bulma.min.css';

import Loading from '../../components/Loading/LoadingModule';
import ChartsRecivedCalls from '../../components/Dashboard/ChartsRecivedCalls';
import ChartsSendedsCalls from '../../components/Dashboard/ChartsSendCalls';
import ReportList from '../../components/Dashboard/ReportList';
import Pagination from '../../components/Dashboard/Pagination';
import ChartCallsStatusGlobal from '../../components/Dashboard/ChartCallsStatusGlobal';
import ChartBySector from '../../components/Dashboard/ChartBySector';
import ChartCallsReceivedsByTime from '../../components/Dashboard/ChartCallsReceivedsByTime';
import ChartCallsSendedsyTime from '../../components/Dashboard/ChartCallsSendedsyTime';
import ChartCallsReceivedsByDay from '../../components/Dashboard/ChartCallsReceivedsByDay';
import ChartCallsSendedsByDay from '../../components/Dashboard/ChartCallsSendedsByDay';
import TableReceivedCalls from '../../components/Dashboard/TableReceivedCalls';
import TableSentCalls from '../../components/Dashboard/TableSentCalls';
import FilterReportsCalls from '../../components/Dashboard/FilterReportsCalls';
import SaveButton from '../../components/Buttons/SaveButton';
import DownloadButton from '../../components/Buttons/DownloadButton';

function Reports() {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport, setStorageDataReport, verifySort, dataForRequestCalls, setDataForRequestCalls } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);

  const [callsReceived, setCallsReceived] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [callsPerPage] = useState(50);
  const [sortElements, setSortElements] = useState({ key: '', direction: 'direction'});
  const [readingDb, setReadingDb] = useState(false);
  const [classButtonGenerateStats, setClassButtonGenerateStats] = useState('');
  const [classButtonGenerateLogs, setClassButtonGenerateLogs] = useState('is-hidden');
  const [classButtonDownloadStats, setClassButtonDownloadStats] = useState('is-hidden');
  const [classButtonDownloadLogs, setClassButtonDownloadLogs] = useState('is-hidden');

  const history = useHistory();
  
  const today = new Date();
  const todayFull = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;


  const fetchDataDashboardIntit = async (filter) => {
    try {
      const data = filter;

      const recEndpointsResult = await chartEndpointsReceiveds(filter);
      const recHoursResult = await chartHoursReceiveds(filter);
      const recSectorsResult = await chartSectorsReceiveds(filter);
      const recDaysResult = await chartDaysReceiveds(filter);
      const recResumeResult = await chartResumeReceiveds(filter);
      const recSendedsEndpointsResult = await chartEndpointsSendeds(filter);
      const recSendedsHoursResult = await chartHoursSendeds(filter);
      const recSendedsDaysResult = await chartDaysSendeds(filter);
      const recSendedsResumeResult = await chartResumeSendeds(filter);
      const recInternalsResumeResult = await chartResumeInternals(filter);
  
      const sectosGlobals = { global: recSectorsResult.totalGlobal ? recSectorsResult.totalGlobal : {} }
      delete recSectorsResult.totalGlobal
  
      const result = {
        endpointsReceiveds: recEndpointsResult,
        endpointsSendeds: recSendedsEndpointsResult,
        queues: recSectorsResult,
        globalQueues: sectosGlobals,
        internalAndExternals: {},
        receivedsHours: recHoursResult,
        sendedsHours: recSendedsHoursResult,
        receivedsDays: recDaysResult,
        sendedsDays: recSendedsDaysResult,
        receivedResume: recResumeResult,
        sendedsResume: recSendedsResumeResult,
        logs: []
      }
      
      return result;
    } catch (error) {
      return setLoading(true);
    }
  };

  const getDataReportDb = useCallback(async (data) => {
    const req = {
      initDate: todayFull,
      endDate: todayFull,
      initHour: `00:00:00`,
      endHour: `23:59:59`,
      sector: '',
      getEndpoint: '',
      telNumber: '',
      getProtocol: '',
      getStatus: '',
      getType: '',
      getLogs: false,
    };
    const filterItems = !data ? req : data;
    const localFetchDataReport = await fetchDataDashboardIntit(filterItems);
    window.localStorage.setItem('filter_data', JSON.stringify(filterItems));
    setDataForRequestCalls(filterItems);

    return localFetchDataReport; 
  }, [setDataForRequestCalls]);

  const getStatsReport = () => setTimeout(() => window.location.replace(`http://${url}/api/report/download-stats`), 1000);
  const getLogsReport = () => setTimeout(() => window.location.replace(`http://${url}/api/report/download-logs`), 1000);

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');

    const localFetchDataReport = await getDataReportDb();
    // console.log(localFetchDataReport);
    
    if (!localFetchDataReport) return setLoading(true);

    setStorageDataReport(localFetchDataReport);

    setLoading(false);
  }, [getDataReportDb, history, setStorageDataReport]);
  
  const sendDataExportReportGeneration = async () => {
    const sendDataReport = await exportReportGenerate(storageDataReport);
    setClassButtonGenerateStats('is-hidden');
    setClassButtonDownloadStats('');
    return;
  };
  
  const sendDataExportReportGenerationLogs = async () => {
    await exportReportGenerateLogs(dataForRequestCalls);
    setClassButtonGenerateLogs('is-hidden');
    setClassButtonDownloadLogs('');
    return;
  };

  const getReportRowsFiltred = async (chart, item, status) => {
    const dataStorage = window.localStorage.getItem('filter_data');
    const data = JSON.parse(dataStorage);
    
    const { dateStart } = data;

    data['getLogs'] = true;

    if (chart === 'endpoints-receiveds' || chart === 'endpoints-sendeds') {
      data['getEndpoint'] = item;
      data['getType'] = chart === 'endpoints-receiveds' ? 'recebida' : 'realizada';
      data['getStatus'] = status;
    }
    if (chart === 'queues') {
      data['sector'] = item;
      data['getStatus'] = status;
    }
    if (chart === 'queues-global') {
      const dataUser = await accessLocalStorage.getUserLocalStorage();
      let queues;
      if (dataUser) {
        const { user: { queuesviewer } } = dataUser;
        queues = queuesviewer !== 'all' ? queuesviewer.split(',') : queuesviewer;
      }
      data['sector'] = queues;
      data['getStatus'] = status;
    }
    if (chart === 'receiveds-hours' || chart === 'sendeds-hours') {
      const hour = item.length === 1 ? `0${item}` : item;
      // data['dateStop'] = dateStart;
      data['initHour'] = `${hour}:00:01`;
      data['endHour'] = `${hour}:59:59`;
      data['getType'] = chart === 'receiveds-hours' ? 'recebida' : 'realizada';
      data['getStatus'] = status;
    }
    if (chart === 'receiveds-days' || chart === 'sendeds-days') {
      const fomatedDay = dateStart.split('-');
      const dateDay = `${fomatedDay[0]}-${fomatedDay[1]}-${item.padStart(2, '0')}`;
      data['dateStart'] = `${dateDay}`;
      data['dateStop'] = `${dateDay}`;
      data['getType'] = chart === 'receiveds-days' ? 'recebida' : 'realizada';
      data['getStatus'] = status;
    }
    if (chart === 'receiveds-table' || chart === 'sendeds-table') {
      data['getType'] = chart === 'receiveds-table' ? 'recebida' : 'realizada';
      if (status) data['getStatus'] = status;
    };

    
    const rows = await logsReport(data);

    if(rows.length > 0) {
      setCallsReceived(rows);
      // console.log(rows);
      
      setClassButtonGenerateLogs('');
      setDataForRequestCalls(data);
      return;
    };
    return;
  };

  const indexOfLastCall = currentPage * callsPerPage;
  const indexofFirstCall = indexOfLastCall - callsPerPage;
  const currentCalls = callsReceived.length > 0 ? callsReceived.slice(indexofFirstCall, indexOfLastCall) : [];
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const sendFilterDashboard = async (data) => {
    const { sector, getEndpoint, telNumber, getProtocol, getType, getLogs } = data;

    data['getLogs'] = getType === 'interna' || telNumber !== '' || getProtocol !== '' || getEndpoint !== '' ? true : getLogs;
    data['sector'] = sector.length > 0 ? sector : '';
    data['getEndpoint'] = getEndpoint.length > 0 ? getEndpoint : '';
    data['telNumber'] = telNumber.length > 0 ? telNumber : '';
    data['getProtocol'] = getProtocol.length > 0 ? getProtocol : '';

    setReadingDb(true);
    const localFetchDataReport = await getDataReportDb(data);
    if (!localFetchDataReport) return;

    setStorageDataReport(localFetchDataReport);
    setCallsReceived(localFetchDataReport.logs);
    setDataForRequestCalls(data);

    if (getType === 'interna') {
      const rows = await logsReport(data);

      if(rows.length > 0) {
        setCallsReceived(rows);
        
        setClassButtonGenerateLogs('');
        setDataForRequestCalls(data);
        setReadingDb(false);
        return;
      };
    };

    setReadingDb(false);
  };

  useMemo(() => {
    let sortableItems = callsReceived;
    if (sortElements !== null) {
      sortableItems.sort((a, b) => {
        if(sortElements.key === 'duracao' && sortElements.direction === 'ascending') return a[sortElements.key] - b[sortElements.key];
        if(sortElements.key === 'duracao' && sortElements.direction === 'descending') return b[sortElements.key] - a[sortElements.key];
        
        if (a[sortElements.key] < b[sortElements.key]) {
          return sortElements.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortElements.key] > b[sortElements.key]) {
          return sortElements.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    setCallsReceived(sortableItems);
    return;
  }, [callsReceived, sortElements]);

  const sortedCalls = (key) => {
    let direction = 'ascending';
    if (sortElements && sortElements.key === key && sortElements.direction === 'ascending') {
      direction = 'descending';
    }
    setSortElements({ key, direction });
    return;
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
          :
          <>
            <div className="columns mx-2 mt-4">
              <ChartsRecivedCalls getRows={ getReportRowsFiltred } />
              <ChartsSendedsCalls getRows={ getReportRowsFiltred } />
            </div>
            <hr className="m-0 p-0"/>
            <div className="columns mx-2">
              <ChartCallsReceivedsByTime  getRows={ getReportRowsFiltred } />
              <ChartCallsSendedsyTime  getRows={ getReportRowsFiltred } />
            </div>
            <hr className="m-0 p-0"/>
            <div className="columns mx-2">
              <ChartCallsStatusGlobal getRows={ getReportRowsFiltred }/>
              <ChartBySector  getRows={ getReportRowsFiltred } />
            </div>
            <hr className="m-0 p-0"/>
            <div className="columns mx-2">
              <ChartCallsReceivedsByDay getRows={ getReportRowsFiltred }/>
              <ChartCallsSendedsByDay getRows={ getReportRowsFiltred }/>
            </div>
            <div className="columns mx-2">
              <TableReceivedCalls getRows={ getReportRowsFiltred } />
              <TableSentCalls getRows={ getReportRowsFiltred } />
            </div>
            {/* <hr className="m-0 p-0"/> */}
            <SaveButton
              generateFile={ sendDataExportReportGeneration }
              classStatus={ classButtonGenerateStats }
            />
            <DownloadButton
              getFileName={ getStatsReport }
              classStatus={ classButtonDownloadStats }
            />
            <hr className="m-0 p-0"/>
            <FilterReportsCalls sendFilterDashboard={ sendFilterDashboard } readingDb={ readingDb } />
            <hr className="m-0 p-0"/>
            <SaveButton
              generateFile={ sendDataExportReportGenerationLogs }
              classStatus={ classButtonGenerateLogs }
            />
            <DownloadButton
              getFileName={ getLogsReport }
              classStatus={ classButtonDownloadLogs }
            />
            {
              callsReceived.length > 0 ?
              <div>
                <ReportList callsList={ currentCalls } sortedCalls={ sortedCalls } verifySort={ verifySort } />
                <Pagination callsPerPage={ callsPerPage } totalCalls={ callsReceived.length } paginate={ paginate } currentPage={ currentPage } />
              </div>
              : null
            }
          </>
      }
    </div>
  );
}

export default Reports;
